<div class="vehicle-history-dialog">
  <div class="vehicle-history-dialog-header flex-between-center">
    <p class="m-0 font-bold">
      <i class="far fa-car"></i>
      <span *ngIf="vehicleInfo?.vehicleName">{{ vehicleInfo?.vehicleName }}</span>
      <span *ngIf="!vehicleInfo?.vehicleName">{{ vehicleInfo?.name }}</span>
      <i class="far fa-link pointer" *ngIf="vehicleInfo?.isMotorConnected" tooltipPosition="top" tooltipStyleClass="motor-vehicle-link-tooltip font-11" [pTooltip]="'Linked to Motor'"></i>
      <i
        class="far fa-link font-yellow pointer"
        *ngIf="!vehicleInfo?.isMotorConnected"
        tooltipPosition="top"
        tooltipStyleClass="motor-vehicle-link-tooltip font-11"
        [pTooltip]="'Not connected to Motor'"
      ></i>
    </p>
    <span class="close-modal">
      <i class="fal fa-times" (click)="closeDialog(null)"></i>
    </span>
  </div>

  <div class="vehicle-dialog-body-wrapper">
    <div class="vehicle-history-dialog-body-upper">
      <div class="vehicle-history-info-wrapper">
        <div class="vehicle-history-info-row row">
          <div class="vehicle-history-info-col-4 col-md-4">
            <div class="vehicle-history-info-box-row">
              <div class="info-left">
                <i class="far fa-car"></i>
                <p>YMM:</p>
              </div>
              <div class="info-content one-line-elipsis">
                {{ this.YMM || '' }}
              </div>
            </div>
            <div class="vehicle-history-info-box-row">
              <div class="info-left">
                <i class="far fa-barcode"></i>
                <p>VIN:</p>
              </div>
              <div class="info-content" [innerHTML]="vehicleInfo?.VIN || '' | highlightVin"></div>
            </div>
            <div class="vehicle-history-info-box-row">
              <div class="info-left">
                <i class="far fa-rectangle-wide"></i>
                <p>License plate:</p>
              </div>
              <div class="info-content">
                {{ vehicleInfo?.licensePlateNo || '' }}
              </div>
            </div>
          </div>

          <div class="col-md-8">
            <div class="row">
              <div class="vehicle-history-info-col-4 address col-md-5">
                <div class="vehicle-history-info-box-row">
                  <div class="info-left">
                    <i class="far fa-map"></i>
                    <p>State:</p>
                  </div>
                  <div class="info-content">
                    {{ vehicleInfo?.registrationStateCode }}
                  </div>
                </div>
                <div class="vehicle-history-info-box-row">
                  <div class="info-left">
                    <i class="far fa-calendar-alt"></i>
                    <p>Created:</p>
                  </div>
                  <div class="info-content">
                    {{ vehicleInfo?.createdAt | date : 'MMM d, y' }}
                  </div>
                </div>
                <div class="vehicle-history-info-box-row">
                  <div class="info-left">
                    <i class="far fa-sign"></i>
                    <p>Mileage:</p>
                  </div>
                  <div class="info-content" *ngIf="ODM && ODM.reading">{{ ODM.reading || '' }} {{ ODM.mileageMeasuringUnit === 'mi' ? 'miles' : 'km' }}</div>
                  <i
                    *ngIf="ODM && ODM.reading"
                    class="fal fa-info-circle text-dark font-gray-55 mileage-info pointer"
                    tooltipStyleClass="ticket-tooltip modifier vehicle-tooltip"
                    tooltipPosition="top"
                    [pTooltip]="showMileageHistory()"
                    [escape]="false"
                  ></i>
                </div>
              </div>
              <div class="vehicle-history-info-col-4 owners col-md-4" *ngIf="!isTransferVehicleEnabled">
                <div class="vehicle-history-info-box-row">
                  <div class="info-left">
                    <i class="far fa-user-check"></i>
                  </div>
                  <div class="info-content one-line-elipsis">
                    {{ vehicleInfo?.customerId?.fullName || '' }}
                  </div>
                </div>
              </div>
              <div class="col-md-7" *ngIf="isTransferVehicleEnabled">
                <div class="transfer-vehicle-history">
                  <div class="heading">
                    <p>Current owner:</p>
                  </div>
                  <div class="info-content">
                    {{ currentOwnerName || 'N/A' }}
                  </div>
                </div>
                <div class="transfer-vehicle-history">
                  <div class="info-left">
                    <p>Previous owner:</p>
                  </div>
                  <div class="d-flex">
                    <ng-container *ngFor="let owner of previousOwnerNames; let i = index">
                      <div class="transfer-users" *ngIf="i < 2">
                        {{ owner?.previousCustomerName || '' }}
                      </div>
                    </ng-container>
                    <div class="transfer-users" *ngIf="previousOwnerNames?.length > 2">+{{ previousOwnerNames?.length - 2 }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="vehicle-history-ro-wrapper">
      <div class="vehicle-history-action-row">
        <div class="vehicle-history-ro-title">
          Repair orders
          <div class="repair-order-count-bubble">
            <span *ngIf="isSearchEntered">Result:</span>
            <span *ngIf="!isTransferVehicleEnabled; else transferROCount">
              {{ ownerVehicleHistory.length }}
            </span>
            <ng-template #transferROCount>
              {{ transferOrderCount }}
            </ng-template>
          </div>
        </div>
        <div class="vehicle-history-ro-filters">
          <div class="search-bar-width" *ngIf="options.isSearchBarOn">
            <app-auto-complete
              placeholder="Search vehicle's repair orders"
              leftIcon="fal fa-search"
              field="title"
              theme="border"
              [closeOnSelection]="true"
              [hasEditableField]="false"
              [hasCustomEditableField]="false"
              [autoFocus]="false"
              [hasSearchIcon]="true"
              [value]="searchQuery"
              (appEnter)="onSearchEnter($event)"
              (appClear)="searchClear()"
              (appCompletedMethod)="searchRepairOrder($event)"
              scrollHeight="1px"
            >
            </app-auto-complete>
          </div>
        </div>
      </div>
    </div>

    <div class="search-empty-screen" *ngIf="ownerVehicleHistory.length === 0 && !isTransferVehicleEnabled">
      <div class="empty-search-vertical" *ngIf="isShowVehicleHistory">
        <img src="assets/placeholders/empty-search-result.png" alt="" />
        <p>There are no estimates.</p>
      </div>
    </div>

    <div class="vehicle-history-service" *ngIf="ownerVehicleHistory.length !== 0 && !isTransferVehicleEnabled">
      <app-vehicle-history-services
        *ngFor="let vehicleHistory of ownerVehicleHistory; let vehicleIndex = index"
        [shopsMap]="shopsMap"
        [vehicleIndex]="vehicleIndex"
        [isMultiLocationEnabled]="isMultiLocationEnabled"
        [vehicleHistory]="vehicleHistory"
        [isSearchEntered]="isSearchEntered"
        [searchQuery]="searchQuery"
        [isTransferVehicleEnabled]="isTransferVehicleEnabled"
      >
      </app-vehicle-history-services>
    </div>

    <div class="search-empty-screen" *ngIf="orderInfo?.currentOwner?.length === 0 && orderInfo?.previousOwner?.length === 0 && isTransferVehicleEnabled">
      <div class="empty-search-vertical" *ngIf="isShowVehicleHistory">
        <img src="assets/placeholders/empty-search-result.png" alt="" />
        <p>There are no estimates.</p>
      </div>
    </div>

    <div class="transfer-owner" *ngIf="orderInfo?.currentOwner?.length > 0 && isTransferVehicleEnabled">
      <div class="owner-name">{{ currentOwnerName || 'N/A' }} (Current owner)</div>
      <div class="border-side"></div>
    </div>

    <div *ngIf="orderInfo?.currentOwner?.length > 0 && isTransferVehicleEnabled">
      <app-vehicle-history-services
        *ngFor="let vehicleHistory of orderInfo?.currentOwner; let vehicleIndex = index"
        [shopsMap]="shopsMap"
        [vehicleIndex]="vehicleIndex"
        [isMultiLocationEnabled]="isMultiLocationEnabled"
        [vehicleHistory]="vehicleHistory"
        [isSearchEntered]="isSearchEntered"
        [searchQuery]="searchQuery"
        [isTransferVehicleEnabled]="isTransferVehicleEnabled"
      >
      </app-vehicle-history-services>
    </div>

    <div *ngIf="orderInfo?.previousOwner?.length > 0 && isTransferVehicleEnabled">
      <div class="previous-owners">Previous Owner(s)</div>

      <ng-container *ngFor="let previous of orderInfo?.previousOwner; let i = index">
        <div class="transfer-border" *ngIf="i !== 0"></div>
        <div class="owner-name">
          {{ previous?.vehicleTransferDetails?.customerName }}&nbsp;<span class="transfer-date"> (transferred on {{ previous?.vehicleTransferDetails?.vehicleTransferDate }})</span>
        </div>

        <app-vehicle-history-services
          *ngFor="let vehicleHistory of previous; let vehicleIndex = index"
          [shopsMap]="shopsMap"
          [vehicleIndex]="vehicleIndex"
          [isMultiLocationEnabled]="isMultiLocationEnabled"
          [vehicleHistory]="vehicleHistory"
          [isSearchEntered]="isSearchEntered"
          [searchQuery]="searchQuery"
          [isTransferVehicleEnabled]="isTransferVehicleEnabled"
        >
        </app-vehicle-history-services>
      </ng-container>
    </div>
  </div>

  <div class="vehicle-history-dialog-footer flex-end-center">
    <button class="btn btn-primary btn-submit" (click)="closeDialog(null)">
      Close
      <i cass="fal fa-spinner rotate"></i>
    </button>
  </div>
</div>
